<template>
  <div>
    <navbar></navbar>
    <toolbar></toolbar>
    <v-content>
      <v-container grid-list-xl>
        <v-layout row fill-height>
          <v-flex>                       
            <automation/>            
          </v-flex>
        </v-layout>  
      </v-container>
    </v-content>
  </div>
</template>

<script>
import navbar from '../components/Navigation-drawer.vue'
import toolbar from '../components/Toolbar.vue'
import automation from '../components/Assets-main.vue'


import {db} from '@/plugins/firebase.js';

  export default { 
    components:{
      navbar,
      toolbar,
      automation
    },
    created(){
      this.fetchData()
    },   
    data: () => ({
        
    }),
    methods:{
        fetchData(){
          let pageid = this.$route.params.page_id 
          this.$store.dispatch('aFetchfbdata')         
          this.$store.dispatch('aFetchpagedata', pageid)
          this.$store.dispatch('aSelectedPage', pageid)
          this.$store.dispatch('afetchresponses')
          this.$store.dispatch('afetchrules')
          this.$store.dispatch('afetchassets')
          this.$store.dispatch('afetchBTemplates')
          this.$store.dispatch('afetchcommmentRules')
        }
    }
  }
</script>

<style>


</style>
